/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import React from 'react'
import EventStream from '../components/event_stream/index'
import Session from '../components/session'

// @ts-expect-error - Legacy route component, not worth fully typing
const EventStreamRoute = props => (
  <div>
    <Session
      submission={props.submission}
      attempt={props.attempt}
      availableAttempts={props.availableAttempts}
    />

    <EventStream
      submission={props.submission}
      events={props.events}
      questions={props.questions}
      attempt={props.attempt}
    />
  </div>
)

export default EventStreamRoute
